import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapScrollState() {
    const body = document.body;

    // Step 2 State (Past 100vh)
    ScrollTrigger.create({
        start: () => window.innerHeight, // Absolute scroll position
        end: "max",
        toggleClass: { targets: body, className: "HAS-REACHED--STEP-2" },
        markers: false,
    });

    // Footer State
    ScrollTrigger.create({
        trigger: "#app-footer",
        start: "top bottom",
        toggleClass: { targets: body, className: "HAS-REACHED--FOOTER" },
        markers: false,
    });

    // Sticky Header State (Past 100px)
    ScrollTrigger.create({
        start: 100,
        end: "max",
        onEnter: () => body.classList.add("IS-HEADER-STICKY"),
        onLeaveBack: () => body.classList.remove("IS-HEADER-STICKY"),
        markers: false,
    });

    // Detect Scroll Direction
    // We use a separate trigger that covers the entire document to ensure updates are always fired
    ScrollTrigger.create({
        start: 0,
        end: "max",
        onUpdate: (self) => {
            // Only update if direction is non-zero (0 means no movement)
            if (self.direction !== 0) {
                const isScrollingDown = self.direction === 1;
                body.classList.toggle("SCROLLING--DOWN", isScrollingDown);
                body.classList.toggle("SCROLLING--UP", !isScrollingDown);
            }
        },
        markers: false,
    });
}
